import {Component} from '@angular/core';

@Component({
  selector: 'app-placeholder',
  template: `
    <ui-view></ui-view>
  `
})
export class PlaceholderComponent {

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/shared/placeholder.component.ts